// import React, {useState, useEffect, Component} from 'react';
import React from 'react';
import './App.css';
// import ReactTable from 'react-table'
// import XLSX from 'xlsx' 
// import ReactToExcel from 'react-html-table-to-excel'
// import ReactExport from "react-export-excel";
// import { VictoryPie, VictoryTooltip } from "victory";

import happyMeter from './happyMeter.json';
import characters from './characters.json'
import firebase from 'firebase'
// import { 
//   FirebaseAppProvider,
//   useFirestore, 
//   SuspenseWithPerf,
//   useFirestoreCollectionData,
// } from 'reactfire';

import data from './firebase.json';
const firebaseConfig = data[0];



firebase.initializeApp(firebaseConfig);

// function Testi(props) {
//   // props.onClick("täätulitestistä");
//   return(
//     <div style={{position: "fixed"}}>
//       <button onClick={() => props.onClick("täätulitestistä")}>paina tätä</button>
//     </div>
//   )
// }

class App extends React.Component {
  constructor() {
    super();
    this.state = {
      initials: '',
      cid: '',
      moodIconId: '',
      registrationDate: '',
      allData: [],
      currentRoom: 'some',
      moodTimestamp: '',
      testi: "tääpitäsmuuttua"
    };
    //  this.exportFile = this.exportFile.bind(this)
  }

  // componentWillMount() {
  //   this.getData()
  // }

  getData = () => {
    const db = firebase.firestore()
    var wholeData = []
    db.collection("production").doc("samk2020").collection(this.state.currentRoom).get()
    .then(snapshot => {
      snapshot.forEach(doc => {
        //console.log(doc.data());
        wholeData.push(doc.data())
      });
      //console.log(wholeData)
      this.setState({allData: wholeData})
      //console.log(this.state.allData)
    })
    .catch(error => {
      console.log('Error!', error);
    })

  }


  changeRoom = (e) => {
    //console.log(e.target.value);
    let c = e.target.value
    this.setState({
      currentRoom: c
    })
  }

  // mainintesti = (data) => {
  //  if(this.state.testi !== data) {
  //     this.setState({
  //       testi: data
  //     })
  //   }
  // }

      
  render() {
    
    var listOfData = this.state.allData.map((val, i)=>{
      //console.log("moro", val)
      var initials = val.initials;
      var cid = val.cid;
      var moodIconId = val.moodIconId;
      // var kokopaska = listOfData.length;

      // const fiilisdata = [
      //   {product: {moodIconId}, sales: {kokopaska}},
      //   ]

      //   return (
      //   <div className="chart-header">Plant Sales</div> 
      //   <VictoryPie
      //      data={data}
      //      x="product"
      //      y="sales"
      //      labels={p => `${p.product}`}
      //   />)

        
      
      let date;

        if (val.registrationDate) {
          var registrationDate;
          if (val.registrationDate.milliseconds) {  
            registrationDate = new Date(val.registrationDate.milliseconds)
          }
          else {
            registrationDate = new Date(val.registrationDate)
          }
          date = registrationDate
          date = date.getDate() + '/' + date.getMonth() + '/' + date.getFullYear()
      
        }

      let date2;

        if (val.moodTimestamp) {
          var moodTimestamp;
          if (val.moodTimestamp.seconds) {
            moodTimestamp = new Date(val.moodTimestamp.seconds * 1000).toLocaleDateString('en-GB')
          }
          else {
            moodTimestamp = new Date(val.moodTimestamp)
          }
          //console.log("moronääs", moodTimestamp)
          date2 = moodTimestamp
          // date2 = date2.getDate() + '.' + date2.getMonth() + '.' + date2.getFullYear() + ' ' +
          //   date2.getHours() + ':' + date2.getMinutes()
        }

      let date3;

        if (val.moodTimestamp) {
          var moodTimestamp2;
          if (val.moodTimestamp.seconds) {
            moodTimestamp2 = new Date(val.moodTimestamp.seconds * 1000).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', second:'2-digit', hour12: false})
          }
          else {
            moodTimestamp2 = new Date(val.moodTimestamp)
          }
          //console.log("moronääs", moodTimestamp)
          date3 = moodTimestamp2

      }
      

    return (
        
    <li key={i}>Nimikirjaimet: {initials} <br></br>
      Hahmo: {characters[cid].icon} <br></br> Fiilis (0 = 😄, 8 = 😢): {moodIconId}/{happyMeter[moodIconId].icon} 
      <br></br>
      Kirjautunut ensimmäisen kerran: {date}<br></br>
      Fiiliksen ajankohta: {date2} klo: {date3}
      {/* {happyMeter[moodIconId].icon}
  */}
    </li>

    
 
      )
    })

    const Emoji = props => (
      <span
        className="emoji"
        role="img"
        aria-label={props.label ? props.label : ""}
        aria-hidden={props.label ? "false" : "true"}
      >
        {props.symbol}
      </span> 
    )

    return (
    
      <div style={{margin:'30px'}}>
        {/* <Testi onClick={(dataa)=> this.mainintesti(dataa)} className="perkele"></Testi> */}
          <h1>Somebody-app/Admin</h1>
            {/* {this.state.testi} */}
          <div className="hymioselitys">Hymiöiden arvot: <br></br>
              0 = <Emoji symbol = "😄"/>, 1 = <Emoji symbol = "😃"/>, 2 = <Emoji symbol = "😀"/>, 
              3 = <Emoji symbol = "😊"/>, 4 = <Emoji symbol = "🙂"/>, 
              5 = <Emoji symbol = "😔"/>, 6 = <Emoji symbol = "🙁"/>, 
              7 = <Emoji symbol = "🥺"/>, 8 = <Emoji symbol = "😢"/>
            </div>

          <input className="tekstikentta" placeholder="Kirjoita huoneen nimi" onChange={(e)=>this.changeRoom(e)} /> 

    <     div className="nappi">
              <button onClick={this.getData}>
                Näytä data
              </button>
            </div>

        <ul>{listOfData}</ul>

      </div>
      
      
      );
      
    }
    
   }

export default App;